var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"9%"}},[_c('div',{staticClass:"dependent maxW"},[_c('i',{staticClass:"ipng image_state01"}),_c('p',[_vm._v("- "+_vm._s(_vm.$t('global.noDataTable'))+" -")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }